'use client';

import type { AlertProps } from './Alert';
import { Alert } from './Alert';

/** Outlined alert as inline notification. Based on MUI Alert: https://mui.com/material-ui/react-alert/ */
export const InlineNotification = ({ children, ...props }: Omit<AlertProps, 'variant'>) => (
  <Alert variant="outlined" {...props}>
    {children}
  </Alert>
);
